export default __webpack_public_path__ + "static/media/blood-observation.3cab5b65.jpg";